module.exports = __webpack_public_path__ + "img/logo_12.3f0eefa1.png";